module.exports = __webpack_public_path__ + "49dd151b4434155e6ac81c7808142463.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/font_uzv8nkw1nabgldi.woff
// module id = 2466
// module chunks = 0